import {
	getOpenReplay,
	initOpenReplayLoader,
	safeOpenReplayCall,
} from './loader';
import {
	getOpenReplayEventContext,
	updateOpenReplaySessionContext,
} from './context';
import { sanitizeOpenReplayPayload } from './sanitize';

export function initOpenReplay(): void {
	initOpenReplayLoader();
}

export function setOpenReplayUser(userId?: string | null): void {
	if (!userId) {
		return;
	}

	safeOpenReplayCall(() => {
		getOpenReplay()?.setUserID?.(String(userId));
	});
}

export function setOpenReplayMetadata(
	key: string,
	value?: string | number | boolean | null,
): void {
	if (value === null || value === undefined || value === '') {
		return;
	}

	safeOpenReplayCall(() => {
		getOpenReplay()?.setMetadata?.(key, String(value));
	});
}

export function setOpenReplaySessionContext(
	userId?: string | null,
	quizId?: string | number | null,
): void {
	updateOpenReplaySessionContext(userId, quizId);

	safeOpenReplayCall(() => {
		const tracker = getOpenReplay();

		if (userId) {
			tracker?.setUserID?.(String(userId));
		}

		if (quizId !== null && quizId !== undefined && quizId !== '') {
			tracker?.setMetadata?.('quizId', String(quizId));
		}

		console.info('[OpenReplay]', 'session context updated', {
			hasUserId: !!userId,
			hasQuizId: quizId !== null && quizId !== undefined && quizId !== '',
		});
	});
}

function appendOpenReplayContext(payload?: unknown): unknown {
	const context = getOpenReplayEventContext();
	const sanitizedPayload = sanitizeOpenReplayPayload(payload);

	if (
		sanitizedPayload !== null
		&& typeof sanitizedPayload === 'object'
		&& !Array.isArray(sanitizedPayload)
	) {
		return {
			...context,
			...sanitizedPayload,
		};
	}

	return context;
}

export function trackOpenReplayEvent(key: string, payload?: unknown): void {
	safeOpenReplayCall(() => {
		getOpenReplay()?.event?.(key, appendOpenReplayContext(payload));
	});
}

export function trackOpenReplayIssue(key: string, payload?: unknown): void {
	safeOpenReplayCall(() => {
		getOpenReplay()?.issue?.(key, appendOpenReplayContext(payload));
	});
}
